const defaultChoices = [
  'gar nicht',
  'kaum',
  'nach Möglichkeit',
  'sehr'
]

export default defaultChoices;